// extracted by mini-css-extract-plugin
export default {"tinted":"MiddleMiddleContent_tinted__rnnoY","placeHolderShimmer":"MiddleMiddleContent_placeHolderShimmer__4yjF4"};